import React, {useEffect, useRef} from "react";
import TopNav from "./TopNav";
import Contact from "./Contact";
import Applogin from "./AppLogin";
import Footer from "./Footer";
import '../assets/css/style.css';

const Layout = ({ children, ...props }) => {

  const backToTopRef = useRef();
  //const contact = useRef();
  const contactComponent = useRef();
  //var contact;
  //const ref = React.createRef();

  useEffect(() => {
    /**
     * Server-side rendering does not provide the 'document' object
     * therefore this import is required either in useEffect or componentDidMount as they
     * are exclusively executed on a client
     */
    
    const AOS = require("aos");
    AOS.init({
      once: true,
    });

    console.log("props:" + JSON.stringify(props))

    const onscroll = (el, listener) => {
      el.addEventListener('scroll', listener)
    }

    let backtotop = backToTopRef.current;
    if (backtotop) {
      console.log("There is a 'backtotop'")
      const toggleBacktotop = () => {
        if (window.scrollY > 100) {
          backtotop.classList.add('active')
        } else {
          backtotop.classList.remove('active')
        }
      }
      window.addEventListener('load', toggleBacktotop)
      onscroll(document, toggleBacktotop)
    }


  }, []);

  return (
    <>   
      <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MTV3V9KS" height="0" width="0" style={{display: 'none', visibility: 'hidden'}}></iframe></noscript>
      <TopNav />
      {children}
      <Contact ref={contactComponent} />
      <Applogin />
      <a href="#home" className="back-to-top d-flex align-items-center justify-content-center" ref={backToTopRef}><i className="bi bi-arrow-up-short"></i></a>
      <Footer />
    </>
  )
}

export default Layout